import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { MaskedLines, Reveal, SectionHeading } from "@/components/Reveal";
import ProductCard from "@/components/ProductCard";
import { useEffect, useState } from "react";
import { fetchProducts } from "@/lib/api";

export default function Accessories() {
  const [accessories, setAccessories] = useState(null);

  useEffect(() => {
    fetchProducts()
      .then((all) => setAccessories(all.filter((p) => p.badge === "Accessory")))
      .catch(() => setAccessories([]));
  }, []);

  return (
    <div className="mx-auto max-w-7xl px-5 pb-24 sm:px-8">
      <section className="py-16 sm:py-20">
        <p className="eyebrow mb-5 flex items-center gap-3">
          <span className="inline-block h-px w-8 bg-volt" />
          Accessories
        </p>
        <h1
          className="font-display font-black tracking-tight text-ink leading-[0.95]"
          style={{ fontSize: "clamp(2.4rem, 6vw, 5rem)" }}
          data-testid="accessories-heading"
        >
          <MaskedLines
            lines={[
              <span key="a">THE FINISHING</span>,
              <span key="b">
                <span className="text-volt">TOUCHES.</span>
              </span>,
            ]}
          />
        </h1>
        <Reveal delay={0.35}>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-zinc-600">
            Small parts, big difference. Plates, pegs, grips, stems and more
            — add them to a combo order or grab them on their own.
          </p>
        </Reveal>
      </section>

      <div className="grid gap-6 md:grid-cols-2" data-testid="accessories-grid">
        {accessories === null && <p className="text-zinc-500">Loading accessories…</p>}
        {accessories && accessories.length === 0 && (
          <p className="text-zinc-500" data-testid="accessories-empty">
            Accessories are being stocked — check back shortly.
          </p>
        )}
        {accessories && accessories.map((p, i) => (
          <ProductCard key={p.id} product={p} delay={i * 0.1} eager={i === 0} />
        ))}
      </div>

      <Reveal delay={0.1} className="mt-14">
        <div className="flex flex-wrap items-center justify-between gap-6 rounded-2xl border border-black/10 bg-surface p-8 sm:p-10">
          <div>
            <p className="eyebrow mb-3">Building the whole thing?</p>
            <h3 className="max-w-lg font-display text-2xl font-extrabold tracking-tight text-ink">
              Accessories pair perfectly with either combo.
            </h3>
          </div>
          <Link
            to="/shop"
            data-testid="accessories-shop-cta"
            className="group inline-flex items-center gap-2 rounded-[3px] bg-volt px-6 py-3 font-display text-sm font-bold uppercase tracking-wide text-white transition-colors duration-200 hover:bg-volt-dim"
          >
            Shop Kits
            <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
          </Link>
        </div>
      </Reveal>
    </div>
  );
}
